module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_01a.c32b9beb.jpg";